import {
  SAVE_LAYERS_CLICKED,
  MODAL_INTERACTION,
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  VIEW_SAVED,
} from '../actions/constants';
import { MODAL_SAVE_LAYERS } from '../util/enums/EnumModals';
import LayerBuilder from '../components/layers/LayerBuilder';
import ModalSaveLayers from '../components/modals/ModalSaveLayers';

const INITIAL_STATE = {
  activeLayers: null, // the Layer objs that make up the view that would be saved
  inactiveLayers: null, // the inactive layers (should also be saved)
  chartConfig: null, // the charting configuration
  name: '', // the name the user will give to the view
  renaming: false, // true if user is just renaming an existing view (NOTE: this is accessed during VIEW_SAVED event)
  readyForSave: false,
  saving: false, // true if currently saving
  showAdvanced: false,
  overwriteExisting: false, // true if they want to overwrite an existing
  existing: null, // this is the selected replacement view
  metricsDimensionConfig: null,
};

// Max length of the save modal textfield characters
const MAX_TEXTFIELD_LENGTH = 600;

function interaction(state, payload) {
  switch (payload.section) {
    case 'nameChanged':
      return {
        ...state,
        name: payload.newValue.substring(0, MAX_TEXTFIELD_LENGTH),
      };
    case 'view-tag-added':
      return { ...state, tags: [...(state.tags || []), payload.tag] };
    case 'view-tag-removed':
      return {
        ...state,
        tags: state.tags.filter(
          (e) => e.id() !== payload.tag.id() || e.name() !== payload.tag.name(),
        ),
      };
    case 'newExistingChanged':
      return {
        ...state,
        overwriteExisting: payload.newValue === 'existing',
        name: '', // reset
        existing: null, // reset
      };
    case 'existingChosen':
      return {
        ...state,
        existing: payload.view,
        name: payload?.view?.name?.() ?? '', // keep same name when overwriting existing
      };
    case 'showAdvanced':
      return { ...state, showAdvanced: true };
    case 'saving':
      return { ...state, saving: true };
    default:
      return state;
  }
}

const modalSaveLayers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VIEW_SAVED: // resets state so that 'saving' is set back to false
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case SAVE_LAYERS_CLICKED: {
      const editingExisting = !!action.payload.viewBeingEdited;
      return {
        ...INITIAL_STATE, // reset
        activeLayers: action.payload.activeLayers,
        inactiveLayers: action.payload.inactiveLayers,
        chartConfig: action.payload.chartConfig,
        overwriteExisting: false, // always display "Save new" first
        name: editingExisting ? action.payload.viewBeingEdited.name() : '',
        readyForSave: editingExisting,
        existingTags: action.payload.existingTags,
        metricsDimensionConfig: action.payload.metricsDimensionConfig,
      };
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_SAVE_LAYERS) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave =
        newState.name.trim().length > 0 && !newState.saving;
      return newState;
    }
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalSaveLayers) {
        return {
          ...INITIAL_STATE,
          existing: action.payload.existing,
          showAdvanced: !!action.payload.existing, // always show advanced if they're editing
          activeLayers: action.payload.json._activeLayers.map((l) =>
            LayerBuilder.build(l),
          ),
          inactiveLayers: action.payload.json._inactiveLayers.map((l) =>
            LayerBuilder.build(l),
          ),
          chartConfig: action.payload.json._chartConfig,
          metricsDimensionConfig: action.payload.json.metricsDimensionsConfig,
          name: action.payload.json._name,
          renaming: true,
          readyForSave: false, // they should at least change something
          tags: action.payload.existing
            ? action.payload.existing.categories()
            : null,
        };
      }
      return state;
    default:
      return state;
  }
};

export { INITIAL_STATE, MAX_TEXTFIELD_LENGTH };
export default modalSaveLayers;
